"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentIdsFromCustomProperties = exports.getContentsUsingScroll = void 0;
const tslib_1 = require("tslib");
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const __elasticsearch_1 = require("../../__elasticsearch");
const ElasticsearchEnums_1 = require("../../__types/__enums/ElasticsearchEnums");
const ReportingEnums_1 = require("../../__types/__enums/ReportingEnums");
const getElasticsearchQueryFromFilters_1 = require("../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const parseElasticsearchResult_1 = require("../__common/parseElasticsearchResult");
const addFilters_1 = require("./common/addFilters");
const contentQueryHelper_1 = require("./common/contentQueryHelper");
function getContentsUsingScroll(scrollId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(ElasticsearchEnums_1.ElasticsearchIndicesUrlMapping.content);
        const result = yield elasticsearchClient.scroll({ scrollId, scroll: '1m' });
        return parseElasticsearchResult_1.parseContentsResult(result);
    });
}
exports.getContentsUsingScroll = getContentsUsingScroll;
function getContentsByQuery(input, scroll) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(ElasticsearchEnums_1.ElasticsearchIndicesUrlMapping.content);
        const { body, from = 0, size = 20, _source } = input;
        let query = {
            index: ElasticsearchEnums_1.ElasticsearchIndicesEnum.OFFERS,
            type: ElasticsearchEnums_1.ElasticsearchTypesEnum.OFFER,
            body
        };
        if (_source) {
            query.body._source = _source;
        }
        if (scroll) {
            query = Object.assign(Object.assign({}, query), { scroll, size });
        }
        else {
            query = Object.assign(Object.assign({}, query), { from, size });
        }
        const result = yield elasticsearchClient.search(query);
        return parseElasticsearchResult_1.parseContentsResult(result);
    });
}
const getCustomPropertiesTermsQuery = (id, fieldValues) => {
    return {
        nested: {
            path: 'customProperties',
            query: {
                bool: {
                    must: [
                        {
                            term: {
                                'customProperties.id': id
                            }
                        },
                        {
                            terms: {
                                'customProperties.values.keyword': fieldValues
                            }
                        }
                    ]
                }
            }
        }
    };
};
function getElasticsearchQueryForCustomProperties(filters) {
    const groupedFilters = groupBy_1.default(filters, 'type');
    const query = { bool: {} };
    Object.keys(groupedFilters).forEach(type => {
        query.bool[type] = groupedFilters[type].map((filter) => getCustomPropertiesTermsQuery(filter.id, filter.values));
    });
    return query;
}
function loadContentsFromContentIds(filters, _source) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const allFilters = filters;
        // adding default filters of isPublished and isDraft for content search
        addFilters_1.addDefaultFiltersForContentSearch(allFilters);
        const groupedFilters = groupBy_1.default(filters, 'name');
        const must = [];
        const combinedQuery = {
            bool: {
                must
            }
        };
        let query1;
        let query2;
        Object.keys(groupedFilters).forEach(name => {
            if (name === ReportingEnums_1.CommonFilterEnum.CUSTOM_PROPERTY) {
                query1 = getElasticsearchQueryForCustomProperties(groupedFilters[name]);
                if (query1 && Object.keys(query1).length >= 0) {
                    combinedQuery.bool.must.push(Object.assign({}, query1));
                }
            }
            else {
                query2 = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(groupedFilters[name]);
                if (query2 && Object.keys(query2).length >= 0) {
                    combinedQuery.bool.must.push(Object.assign({}, query2));
                }
            }
        });
        if (combinedQuery.bool.must.length > 0) {
            const query = { size: 1000, _source, body: { query: combinedQuery } };
            // Fetching the first batch of contents using query and getting scrollId
            const elasticsearchResult = yield getContentsByQuery(query, '30s');
            const { scrollId, contents, total } = elasticsearchResult;
            // Fetching remaing batch of contents using scroll
            return contentQueryHelper_1.fetchFromScroll({
                total,
                contents,
                scrollId
            });
        }
        return [];
    });
}
function getContentIdsFromCustomProperties(filters) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const _source = { includes: ['_id'] };
        const contents = yield loadContentsFromContentIds(filters, _source);
        return { contents, total: contents.length };
    });
}
exports.getContentIdsFromCustomProperties = getContentIdsFromCustomProperties;
//# sourceMappingURL=getContentIdsFromCustomProperties.js.map